@file:OptIn(InternalResourceApi::class)

package quip.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/quip.composeapp.generated.resources/"

public val Res.string.add_document: StringResource by lazy {
      StringResource("string:add_document", "add_document", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 10, 36),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10, 44),
      ))
    }

public val Res.string.add_maintenance: StringResource by lazy {
      StringResource("string:add_maintenance", "add_maintenance", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 47, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 55, 51),
      ))
    }

public val Res.string.add_new_vehicle: StringResource by lazy {
      StringResource("string:add_new_vehicle", "add_new_vehicle", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 91, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 107, 55),
      ))
    }

public val Res.string.add_spare_part: StringResource by lazy {
      StringResource("string:add_spare_part", "add_spare_part", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 135, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 163, 46),
      ))
    }

public val Res.string.add_to_calendar: StringResource by lazy {
      StringResource("string:add_to_calendar", "add_to_calendar", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 178, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 210, 51),
      ))
    }

public val Res.string.add_vehicle: StringResource by lazy {
      StringResource("string:add_vehicle", "add_vehicle", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 222, 35),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 262, 43),
      ))
    }

public val Res.string.additional_info_label: StringResource by lazy {
      StringResource("string:additional_info_label", "additional_info_label", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 258, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 306, 61),
      ))
    }

public val Res.string.app_name: StringResource by lazy {
      StringResource("string:app_name", "app_name", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 320, 24),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 368, 24),
      ))
    }

public val Res.string.app_top_bar_title_garage: StringResource by lazy {
      StringResource("string:app_top_bar_title_garage", "app_top_bar_title_garage", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 345, 40),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 393, 40),
      ))
    }

public val Res.string.app_top_bar_title_maintenances: StringResource by lazy {
      StringResource("string:app_top_bar_title_maintenances", "app_top_bar_title_maintenances", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 386, 54),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 434, 58),
      ))
    }

public val Res.string.are_you_sure_delete_document: StringResource by lazy {
      StringResource("string:are_you_sure_delete_document", "are_you_sure_delete_document", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 441, 100),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 493, 108),
      ))
    }

public val Res.string.battery_specs: StringResource by lazy {
      StringResource("string:battery_specs", "battery_specs", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 542, 41),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 602, 65),
      ))
    }

public val Res.string.brand: StringResource by lazy {
      StringResource("string:brand", "brand", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 584, 21),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 668, 21),
      ))
    }

public val Res.string.cancel: StringResource by lazy {
      StringResource("string:cancel", "cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 606, 22),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 690, 26),
      ))
    }

public val Res.string.category_header: StringResource by lazy {
      StringResource("string:category_header", "category_header", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 629, 35),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 717, 39),
      ))
    }

public val Res.string.category_label: StringResource by lazy {
      StringResource("string:category_label", "category_label", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 665, 34),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 757, 38),
      ))
    }

public val Res.string.close: StringResource by lazy {
      StringResource("string:close", "close", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 700, 21),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 796, 21),
      ))
    }

public val Res.string.color: StringResource by lazy {
      StringResource("string:color", "color", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 722, 21),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 818, 21),
      ))
    }

public val Res.string.complete_required_fields: StringResource by lazy {
      StringResource("string:complete_required_fields", "complete_required_fields", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 744, 76),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 840, 80),
      ))
    }

public val Res.string.coolant_type: StringResource by lazy {
      StringResource("string:coolant_type", "coolant_type", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 821, 36),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 921, 48),
      ))
    }

public val Res.string.cost_label: StringResource by lazy {
      StringResource("string:cost_label", "cost_label", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 858, 26),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 970, 26),
      ))
    }

public val Res.string.create_maintenance_confirm: StringResource by lazy {
      StringResource("string:create_maintenance_confirm", "create_maintenance_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 885, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 997, 42),
      ))
    }

public val Res.string.create_maintenance_message: StringResource by lazy {
      StringResource("string:create_maintenance_message", "create_maintenance_message", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 928, 102),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1040, 110),
      ))
    }

public val Res.string.create_maintenance_title: StringResource by lazy {
      StringResource("string:create_maintenance_title", "create_maintenance_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 1031, 56),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1151, 60),
      ))
    }

public val Res.string.cylinder_count: StringResource by lazy {
      StringResource("string:cylinder_count", "cylinder_count", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 1088, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1212, 50),
      ))
    }

public val Res.string.cylinders: StringResource by lazy {
      StringResource("string:cylinders", "cylinders", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 1131, 29),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1263, 29),
      ))
    }

public val Res.string.date: StringResource by lazy {
      StringResource("string:date", "date", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 1188, 20),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1320, 20),
      ))
    }

public val Res.string.date_label: StringResource by lazy {
      StringResource("string:date_label", "date_label", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 1161, 26),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1293, 26),
      ))
    }

public val Res.string.delete: StringResource by lazy {
      StringResource("string:delete", "delete", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 1453, 22),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1617, 26),
      ))
    }

public val Res.string.delete_document: StringResource by lazy {
      StringResource("string:delete_document", "delete_document", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 1209, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1341, 47),
      ))
    }

public val Res.string.delete_maintenance_message: StringResource by lazy {
      StringResource("string:delete_maintenance_message", "delete_maintenance_message", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 1253, 142),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1389, 162),
      ))
    }

public val Res.string.delete_maintenance_title: StringResource by lazy {
      StringResource("string:delete_maintenance_title", "delete_maintenance_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 1396, 56),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1552, 64),
      ))
    }

public val Res.string.description: StringResource by lazy {
      StringResource("string:description", "description", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 1476, 35),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1644, 35),
      ))
    }

public val Res.string.document_add_fab: StringResource by lazy {
      StringResource("string:document_add_fab", "document_add_fab", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 1512, 40),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1680, 48),
      ))
    }

public val Res.string.document_created_at: StringResource by lazy {
      StringResource("string:document_created_at", "document_created_at", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 1553, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1729, 51),
      ))
    }

public val Res.string.document_delete_cancel: StringResource by lazy {
      StringResource("string:document_delete_cancel", "document_delete_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 1597, 38),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1781, 42),
      ))
    }

public val Res.string.document_delete_confirm: StringResource by lazy {
      StringResource("string:document_delete_confirm", "document_delete_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 1636, 39),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1824, 43),
      ))
    }

public val Res.string.document_delete_content_description: StringResource by lazy {
      StringResource("string:document_delete_content_description", "document_delete_content_description", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 1676, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1868, 55),
      ))
    }

public val Res.string.document_delete_message: StringResource by lazy {
      StringResource("string:document_delete_message", "document_delete_message", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 1728, 83),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1924, 95),
      ))
    }

public val Res.string.document_delete_title: StringResource by lazy {
      StringResource("string:document_delete_title", "document_delete_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 1812, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2020, 53),
      ))
    }

public val Res.string.document_details_title: StringResource by lazy {
      StringResource("string:document_details_title", "document_details_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 1862, 54),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2074, 62),
      ))
    }

public val Res.string.document_list_empty: StringResource by lazy {
      StringResource("string:document_list_empty", "document_list_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 1917, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2137, 67),
      ))
    }

public val Res.string.document_list_title: StringResource by lazy {
      StringResource("string:document_list_title", "document_list_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 1973, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2205, 59),
      ))
    }

public val Res.string.document_name: StringResource by lazy {
      StringResource("string:document_name", "document_name", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 2025, 29),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2265, 29),
      ))
    }

public val Res.string.document_rename_cancel: StringResource by lazy {
      StringResource("string:document_rename_cancel", "document_rename_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 2055, 38),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2295, 42),
      ))
    }

public val Res.string.document_rename_confirm: StringResource by lazy {
      StringResource("string:document_rename_confirm", "document_rename_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 2094, 39),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2338, 43),
      ))
    }

public val Res.string.document_rename_message: StringResource by lazy {
      StringResource("string:document_rename_message", "document_rename_message", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 2134, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2382, 67),
      ))
    }

public val Res.string.document_rename_title: StringResource by lazy {
      StringResource("string:document_rename_title", "document_rename_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 2186, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2450, 57),
      ))
    }

public val Res.string.document_share_content_description: StringResource by lazy {
      StringResource("string:document_share_content_description", "document_share_content_description", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 2236, 50),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2508, 54),
      ))
    }

public val Res.string.document_size: StringResource by lazy {
      StringResource("string:document_size", "document_size", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 2287, 29),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2563, 33),
      ))
    }

public val Res.string.document_updated_at: StringResource by lazy {
      StringResource("string:document_updated_at", "document_updated_at", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 2317, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2597, 59),
      ))
    }

public val Res.string.documents: StringResource by lazy {
      StringResource("string:documents", "documents", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 2361, 29),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2657, 33),
      ))
    }

public val Res.string.durability_days_label: StringResource by lazy {
      StringResource("string:durability_days_label", "durability_days_label", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 2391, 53),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2691, 57),
      ))
    }

public val Res.string.edit_maintenance: StringResource by lazy {
      StringResource("string:edit_maintenance", "edit_maintenance", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 2445, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2749, 52),
      ))
    }

public val Res.string.edit_vehicle: StringResource by lazy {
      StringResource("string:edit_vehicle", "edit_vehicle", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 2494, 36),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2802, 44),
      ))
    }

public val Res.string.engine_details: StringResource by lazy {
      StringResource("string:engine_details", "engine_details", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 2531, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2847, 46),
      ))
    }

public val Res.string.engine_oil: StringResource by lazy {
      StringResource("string:engine_oil", "engine_oil", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 2574, 34),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2894, 42),
      ))
    }

public val Res.string.error_adding_maintenance: StringResource by lazy {
      StringResource("string:error_adding_maintenance", "error_adding_maintenance", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 2609, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2937, 76),
      ))
    }

public val Res.string.error_adding_vehicle: StringResource by lazy {
      StringResource("string:error_adding_vehicle", "error_adding_vehicle", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 2674, 68),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3014, 76),
      ))
    }

public val Res.string.error_deleting_maintenance: StringResource by lazy {
      StringResource("string:error_deleting_maintenance", "error_deleting_maintenance", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 2743, 70),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3091, 82),
      ))
    }

public val Res.string.first_registration_date: StringResource by lazy {
      StringResource("string:first_registration_date", "first_registration_date", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 2814, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3174, 71),
      ))
    }

public val Res.string.front_above_160: StringResource by lazy {
      StringResource("string:front_above_160", "front_above_160", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 2878, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3246, 51),
      ))
    }

public val Res.string.front_below_160: StringResource by lazy {
      StringResource("string:front_below_160", "front_below_160", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 2922, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3298, 51),
      ))
    }

public val Res.string.front_bulb_type: StringResource by lazy {
      StringResource("string:front_bulb_type", "front_bulb_type", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 2966, 39),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3350, 51),
      ))
    }

public val Res.string.front_tire_pressure_above_160: StringResource by lazy {
      StringResource("string:front_tire_pressure_above_160", "front_tire_pressure_above_160", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 3006, 77),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3402, 105),
      ))
    }

public val Res.string.front_tire_pressure_below_160: StringResource by lazy {
      StringResource("string:front_tire_pressure_below_160", "front_tire_pressure_below_160", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 3084, 77),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3508, 105),
      ))
    }

public val Res.string.front_tire_size: StringResource by lazy {
      StringResource("string:front_tire_size", "front_tire_size", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 3162, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3614, 67),
      ))
    }

public val Res.string.front_tires: StringResource by lazy {
      StringResource("string:front_tires", "front_tires", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 3206, 35),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3682, 51),
      ))
    }

public val Res.string.general_information: StringResource by lazy {
      StringResource("string:general_information", "general_information", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 3242, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3734, 55),
      ))
    }

public val Res.string.group_by_year: StringResource by lazy {
      StringResource("string:group_by_year", "group_by_year", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 3298, 41),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3790, 45),
      ))
    }

public val Res.string.hello_world: StringResource by lazy {
      StringResource("string:hello_world", "hello_world", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 3340, 35),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3836, 39),
      ))
    }

public val Res.string.home: StringResource by lazy {
      StringResource("string:home", "home", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 3376, 20),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3876, 20),
      ))
    }

public val Res.string.important_dates: StringResource by lazy {
      StringResource("string:important_dates", "important_dates", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 3397, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3897, 47),
      ))
    }

public val Res.string.info_label: StringResource by lazy {
      StringResource("string:info_label", "info_label", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 3441, 26),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3945, 26),
      ))
    }

public val Res.string.kilometers_label: StringResource by lazy {
      StringResource("string:kilometers_label", "kilometers_label", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 3468, 40),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3972, 40),
      ))
    }

public val Res.string.login_already_have_account: StringResource by lazy {
      StringResource("string:login_already_have_account", "login_already_have_account", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 3509, 78),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4013, 82),
      ))
    }

public val Res.string.login_continue_without_sign_in: StringResource by lazy {
      StringResource("string:login_continue_without_sign_in", "login_continue_without_sign_in", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 3588, 74),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4096, 78),
      ))
    }

public val Res.string.login_create_account: StringResource by lazy {
      StringResource("string:login_create_account", "login_create_account", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 3663, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4175, 44),
      ))
    }

public val Res.string.login_dont_have_account: StringResource by lazy {
      StringResource("string:login_dont_have_account", "login_dont_have_account", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 3712, 75),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4220, 75),
      ))
    }

public val Res.string.login_email: StringResource by lazy {
      StringResource("string:login_email", "login_email", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 3788, 27),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4296, 47),
      ))
    }

public val Res.string.login_google_unavailable: StringResource by lazy {
      StringResource("string:login_google_unavailable", "login_google_unavailable", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 3816, 152),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4344, 204),
      ))
    }

public val Res.string.login_name_label: StringResource by lazy {
      StringResource("string:login_name_label", "login_name_label", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 3969, 32),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4549, 32),
      ))
    }

public val Res.string.login_or_continue_with: StringResource by lazy {
      StringResource("string:login_or_continue_with", "login_or_continue_with", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 4002, 54),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4582, 50),
      ))
    }

public val Res.string.login_password: StringResource by lazy {
      StringResource("string:login_password", "login_password", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 4057, 34),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4633, 38),
      ))
    }

public val Res.string.login_sign_in: StringResource by lazy {
      StringResource("string:login_sign_in", "login_sign_in", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 4149, 33),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4737, 41),
      ))
    }

public val Res.string.login_sign_in_google: StringResource by lazy {
      StringResource("string:login_sign_in_google", "login_sign_in_google", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 4092, 56),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4672, 64),
      ))
    }

public val Res.string.login_sign_up_button: StringResource by lazy {
      StringResource("string:login_sign_up_button", "login_sign_up_button", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 4183, 40),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4779, 44),
      ))
    }

public val Res.string.login_sign_up_subtitle: StringResource by lazy {
      StringResource("string:login_sign_up_subtitle", "login_sign_up_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 4224, 62),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4824, 66),
      ))
    }

public val Res.string.login_subtitle: StringResource by lazy {
      StringResource("string:login_subtitle", "login_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 4287, 58),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4891, 74),
      ))
    }

public val Res.string.login_welcome: StringResource by lazy {
      StringResource("string:login_welcome", "login_welcome", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 4346, 41),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4966, 45),
      ))
    }

public val Res.string.maintenance_added_successfully: StringResource by lazy {
      StringResource("string:maintenance_added_successfully", "maintenance_added_successfully", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 4388, 78),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5012, 86),
      ))
    }

public val Res.string.maintenance_cost: StringResource by lazy {
      StringResource("string:maintenance_cost", "maintenance_cost", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 4677, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5309, 56),
      ))
    }

public val Res.string.maintenance_cost_currency_cny: StringResource by lazy {
      StringResource("string:maintenance_cost_currency_cny", "maintenance_cost_currency_cny", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 4467, 41),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5099, 41),
      ))
    }

public val Res.string.maintenance_cost_currency_eur: StringResource by lazy {
      StringResource("string:maintenance_cost_currency_eur", "maintenance_cost_currency_eur", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 4509, 41),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5141, 41),
      ))
    }

public val Res.string.maintenance_cost_currency_gbp: StringResource by lazy {
      StringResource("string:maintenance_cost_currency_gbp", "maintenance_cost_currency_gbp", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 4551, 41),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5183, 41),
      ))
    }

public val Res.string.maintenance_cost_currency_jpy: StringResource by lazy {
      StringResource("string:maintenance_cost_currency_jpy", "maintenance_cost_currency_jpy", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 4593, 41),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5225, 41),
      ))
    }

public val Res.string.maintenance_cost_currency_usd: StringResource by lazy {
      StringResource("string:maintenance_cost_currency_usd", "maintenance_cost_currency_usd", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 4635, 41),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5267, 41),
      ))
    }

public val Res.string.maintenance_deleted_successfully: StringResource by lazy {
      StringResource("string:maintenance_deleted_successfully", "maintenance_deleted_successfully", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 4726, 84),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5366, 92),
      ))
    }

public val Res.string.maintenance_details: StringResource by lazy {
      StringResource("string:maintenance_details", "maintenance_details", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 4811, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5459, 63),
      ))
    }

public val Res.string.maintenance_notes: StringResource by lazy {
      StringResource("string:maintenance_notes", "maintenance_notes", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 4867, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5523, 57),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("add_document", Res.string.add_document)
  map.put("add_maintenance", Res.string.add_maintenance)
  map.put("add_new_vehicle", Res.string.add_new_vehicle)
  map.put("add_spare_part", Res.string.add_spare_part)
  map.put("add_to_calendar", Res.string.add_to_calendar)
  map.put("add_vehicle", Res.string.add_vehicle)
  map.put("additional_info_label", Res.string.additional_info_label)
  map.put("app_name", Res.string.app_name)
  map.put("app_top_bar_title_garage", Res.string.app_top_bar_title_garage)
  map.put("app_top_bar_title_maintenances", Res.string.app_top_bar_title_maintenances)
  map.put("are_you_sure_delete_document", Res.string.are_you_sure_delete_document)
  map.put("battery_specs", Res.string.battery_specs)
  map.put("brand", Res.string.brand)
  map.put("cancel", Res.string.cancel)
  map.put("category_header", Res.string.category_header)
  map.put("category_label", Res.string.category_label)
  map.put("close", Res.string.close)
  map.put("color", Res.string.color)
  map.put("complete_required_fields", Res.string.complete_required_fields)
  map.put("coolant_type", Res.string.coolant_type)
  map.put("cost_label", Res.string.cost_label)
  map.put("create_maintenance_confirm", Res.string.create_maintenance_confirm)
  map.put("create_maintenance_message", Res.string.create_maintenance_message)
  map.put("create_maintenance_title", Res.string.create_maintenance_title)
  map.put("cylinder_count", Res.string.cylinder_count)
  map.put("cylinders", Res.string.cylinders)
  map.put("date", Res.string.date)
  map.put("date_label", Res.string.date_label)
  map.put("delete", Res.string.delete)
  map.put("delete_document", Res.string.delete_document)
  map.put("delete_maintenance_message", Res.string.delete_maintenance_message)
  map.put("delete_maintenance_title", Res.string.delete_maintenance_title)
  map.put("description", Res.string.description)
  map.put("document_add_fab", Res.string.document_add_fab)
  map.put("document_created_at", Res.string.document_created_at)
  map.put("document_delete_cancel", Res.string.document_delete_cancel)
  map.put("document_delete_confirm", Res.string.document_delete_confirm)
  map.put("document_delete_content_description", Res.string.document_delete_content_description)
  map.put("document_delete_message", Res.string.document_delete_message)
  map.put("document_delete_title", Res.string.document_delete_title)
  map.put("document_details_title", Res.string.document_details_title)
  map.put("document_list_empty", Res.string.document_list_empty)
  map.put("document_list_title", Res.string.document_list_title)
  map.put("document_name", Res.string.document_name)
  map.put("document_rename_cancel", Res.string.document_rename_cancel)
  map.put("document_rename_confirm", Res.string.document_rename_confirm)
  map.put("document_rename_message", Res.string.document_rename_message)
  map.put("document_rename_title", Res.string.document_rename_title)
  map.put("document_share_content_description", Res.string.document_share_content_description)
  map.put("document_size", Res.string.document_size)
  map.put("document_updated_at", Res.string.document_updated_at)
  map.put("documents", Res.string.documents)
  map.put("durability_days_label", Res.string.durability_days_label)
  map.put("edit_maintenance", Res.string.edit_maintenance)
  map.put("edit_vehicle", Res.string.edit_vehicle)
  map.put("engine_details", Res.string.engine_details)
  map.put("engine_oil", Res.string.engine_oil)
  map.put("error_adding_maintenance", Res.string.error_adding_maintenance)
  map.put("error_adding_vehicle", Res.string.error_adding_vehicle)
  map.put("error_deleting_maintenance", Res.string.error_deleting_maintenance)
  map.put("first_registration_date", Res.string.first_registration_date)
  map.put("front_above_160", Res.string.front_above_160)
  map.put("front_below_160", Res.string.front_below_160)
  map.put("front_bulb_type", Res.string.front_bulb_type)
  map.put("front_tire_pressure_above_160", Res.string.front_tire_pressure_above_160)
  map.put("front_tire_pressure_below_160", Res.string.front_tire_pressure_below_160)
  map.put("front_tire_size", Res.string.front_tire_size)
  map.put("front_tires", Res.string.front_tires)
  map.put("general_information", Res.string.general_information)
  map.put("group_by_year", Res.string.group_by_year)
  map.put("hello_world", Res.string.hello_world)
  map.put("home", Res.string.home)
  map.put("important_dates", Res.string.important_dates)
  map.put("info_label", Res.string.info_label)
  map.put("kilometers_label", Res.string.kilometers_label)
  map.put("login_already_have_account", Res.string.login_already_have_account)
  map.put("login_continue_without_sign_in", Res.string.login_continue_without_sign_in)
  map.put("login_create_account", Res.string.login_create_account)
  map.put("login_dont_have_account", Res.string.login_dont_have_account)
  map.put("login_email", Res.string.login_email)
  map.put("login_google_unavailable", Res.string.login_google_unavailable)
  map.put("login_name_label", Res.string.login_name_label)
  map.put("login_or_continue_with", Res.string.login_or_continue_with)
  map.put("login_password", Res.string.login_password)
  map.put("login_sign_in", Res.string.login_sign_in)
  map.put("login_sign_in_google", Res.string.login_sign_in_google)
  map.put("login_sign_up_button", Res.string.login_sign_up_button)
  map.put("login_sign_up_subtitle", Res.string.login_sign_up_subtitle)
  map.put("login_subtitle", Res.string.login_subtitle)
  map.put("login_welcome", Res.string.login_welcome)
  map.put("maintenance_added_successfully", Res.string.maintenance_added_successfully)
  map.put("maintenance_cost", Res.string.maintenance_cost)
  map.put("maintenance_cost_currency_cny", Res.string.maintenance_cost_currency_cny)
  map.put("maintenance_cost_currency_eur", Res.string.maintenance_cost_currency_eur)
  map.put("maintenance_cost_currency_gbp", Res.string.maintenance_cost_currency_gbp)
  map.put("maintenance_cost_currency_jpy", Res.string.maintenance_cost_currency_jpy)
  map.put("maintenance_cost_currency_usd", Res.string.maintenance_cost_currency_usd)
  map.put("maintenance_deleted_successfully", Res.string.maintenance_deleted_successfully)
  map.put("maintenance_details", Res.string.maintenance_details)
  map.put("maintenance_notes", Res.string.maintenance_notes)
}
